export default "__VITE_ASSET__6043a97f__"